"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDotSize = void 0;
const getDotSize = ({
  isActive = false,
  isNext = false,
  isPrevious = false
} = {}) => {
  if (isActive) {
    return '12px';
  } else if (isNext || isPrevious) {
    return '6px';
  }
  return '10px';
};
exports.getDotSize = getDotSize;
